import { createApp } from '@shopify/app-bridge';
import { initializeWebVitals } from '@shopify/app-bridge/actions/WebVitals/actions';

// THE single App Bridge instance for the whole app. There used to be three
// separate createApp() calls (here, src/api/index.js, and rest/utils/fetchInstance.ts)
// racing each other; App Bridge only reports Core Web Vitals from one instance,
// so the extra ones both wasted work and made the reporting non-deterministic.
// Everything that needs App Bridge now goes through initAppBridge/getAppBridge.
let app = null;
let webVitalsStarted = false;

export function initAppBridge(host) {
  if (app) return app;

  const apiKey = process.env.REACT_APP_API_KEY;
  if (!apiKey || !host) return null;

  app = createApp({
    apiKey,
    host,
    forceRedirect: false,
  });

  startWebVitals();

  return app;
}

// Built for Shopify measures LCP/CLS/INP from what App Bridge reports, and needs
// 100+ reported sessions before the app is even eligible. This used to live in
// Api.setAppBridge(), which is only ever called on the support-login path with
// loggedInAsUser=true — the exact branch that skipped it. So it never ran for a
// real embedded merchant and Shopify received nothing. Hanging it off the single
// initAppBridge() means it runs on every embedded boot, once.
function startWebVitals() {
  if (webVitalsStarted || !app) return;
  webVitalsStarted = true;
  try {
    initializeWebVitals(app);
  } catch (error) {
    console.error('[shopifyNav] initializeWebVitals failed:', error);
  }
}

export function getAppBridge() {
  return app;
}

export async function openWidgetsNewTab(tab) {
  var shopify = window['shopify'] || {};
  const shopName=shopify.config?.shop?.replace('.myshopify.com','');
  const shopifyWidgetPath='https://admin.shopify.com/store/'+shopName+'/apps/'+(process.env.REACT_APP_SHOPIFY_APP_SLUG)+'/widgets'+(tab !== undefined ? `/${tab}` : '');
  // The embedded App Bridge "Unsaved changes" save bar intercepts window.open and just
  // SHAKES instead of opening the tab. Release it first, open the widget settings in a
  // new admin tab, then re-show it — we are NOT leaving this page, so the merchant keeps
  // their in-progress draft + Save/Discard prompt.
  try { await window.shopify?.saveBar?.hide('save-bar'); } catch (e) {}
  window.open(shopifyWidgetPath, '_blank', 'noreferrer');
  try { await window.shopify?.saveBar?.show('save-bar'); } catch (e) {}
}

// Opens the Shopify theme editor with our app embed pre-selected, so the
// merchant can enable the theme extension. Mirrors the onboarding "Activate
// Theme Extension" deep link. Falls back to the widgets page if we can't build
// the deep link (missing shop domain or api key).
//
// Per Shopify's own docs (shopify.dev/docs/apps/build/online-store/theme-app-extensions/configuration):
//   .../editor?context=apps&template=${template}&activateAppId={api_key}/{handle}
// `{api_key}` is explicitly the app's api_key/client_id (REACT_APP_API_KEY) —
// NOT the theme extension's own UUID (REACT_APP_APP_EXTENSION_UUID, which is
// only for the DIFFERENT `addAppBlockId` deep-link form for section app
// blocks). Using the extension UUID here is what was causing Shopify's
// "App embed does not exist" error even after the block handle was fixed.
export async function openThemeAppEmbed() {
  var shopify = window['shopify'] || {};
  const shopDomain = shopify.config?.shop; // e.g. mystore.myshopify.com
  const apiKey = process.env.REACT_APP_API_KEY;
  if (!shopDomain || !apiKey) {
    openWidgetsNewTab();
    return;
  }
  const url = `https://${shopDomain}/admin/themes/current/editor?context=apps&template=index&activateAppId=${apiKey}/MoqRestriction`;
  // Release the App Bridge save bar first so window.open isn't swallowed (it shakes the
  // bar instead of opening while "Unsaved changes" is up), then re-show it.
  try { await window.shopify?.saveBar?.hide('save-bar'); } catch (e) {}
  window.open(url, '_blank', 'noreferrer');
  try { await window.shopify?.saveBar?.show('save-bar'); } catch (e) {}
}

// Open an EXTERNAL url (e.g. a primemoq.app/help article) in a new tab from inside a
// builder where the App Bridge "Unsaved changes" save bar may be up. Uses the SAME
// mechanism as openWidgetsNewTab (the "Customization and preview" link that already
// works): release the save bar so App Bridge doesn't swallow window.open (it shakes
// the bar instead of opening), open the tab, then re-show it — the merchant keeps
// their in-progress draft + Save/Discard prompt.
export async function openExternalNewTab(url) {
  if (!url) return;
  try { await window.shopify?.saveBar?.hide('save-bar'); } catch (e) {}
  window.open(url, '_blank', 'noreferrer');
  try { await window.shopify?.saveBar?.show('save-bar'); } catch (e) {}
}

export function openEditCampaginInNewTab(id) {
  var shopify = window['shopify'] || {};
  const shopName=shopify.config?.shop.replace('.myshopify.com','');
  const shopifyWidgetPath='https://admin.shopify.com/store/'+shopName+'/apps/'+(process.env.REACT_APP_SHOPIFY_APP_SLUG || 'migratorapp')+'/campaigns/edit-campaign/'+(id !== undefined ? `${id}` : '');
 window.open(shopifyWidgetPath, '_blank', 'noreferrer');
}
